module.exports = __webpack_public_path__ + "static/favicon-92aa554e37e8be6e9e06fd2a6d050dbf.ico";